import Modal from "../../../../modal";
import Checkbox from "../../../../checkbox";
import { Select, Option } from "../../../../select";
import styles from "./styles.module.css";
import { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { functions } from "../../../../firebase";
import Table from "../../../../editors/table";
import { DatabaseValue } from "../../../../contexts/database";
import { LoaderDisbatch } from "../../../../contexts/loader";

const addPage = functions.httpsCallable("addPage");
export default function AddPage({
  pageNames = [],
  appId,
  setOpen: setDropown,
}) {
  const setLoader = useContext(LoaderDisbatch);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [dynamic, setDynamic] = useState(false);
  const [dynamicValue, setDynamicValue] = useState({
    type: "user",
    slug: "_id",
  });
  const history = useHistory();

  const handleAddPage = async (e) => {
    e.preventDefault();
    const allowed = /^[a-z\-]+$/.test(name);

    if (!allowed) {
      alert("Please Format the Page Name Correctly");
      return;
    }

    if (pageNames.includes(name)) {
      alert("Sorry, a page with that name already exists");
      return;
    }
    try {
      setLoader(true);
      const {
        data: { pageId },
      } = await addPage({
        name,
        appId,
        dynamic: dynamic ? dynamicValue : null,
        order: pageNames.length - 1,
      });
      setOpen(false);
      setName(false);
      setDynamic(false);
      setDynamicValue({
        type: "user",
        slug: "_id",
      });
      setDropown(false);
      history.push(`/${appId}/canvas/pages/${pageId}`);
      setLoader(false);
    } catch (err) {
      console.log(err);
      setLoader(false);
      alert("sorry, we ran into a bug and couldn't create a new page");
    }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} className={styles.add}>
        Add Page
      </button>
      <Modal open={open} onClose={() => setOpen(false)}>
        <div onMouseDown={(e) => e.stopPropagation()} className={styles.modal}>
          <div className={styles.modalTitle}>Add Page</div>
          <div className={styles.inputTitle}>Page Name</div>
          <input
            className="input"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <div className={styles.hint}>
            Should be all lowercase and only contain a-z or -
          </div>
          <div style={{ marginTop: 20 }} className={styles.inputTitle}>
            Make this page path dynamic?
          </div>
          <Checkbox checked={dynamic} onChange={setDynamic} />
          {dynamic && (
            <DynamicSection value={dynamicValue} onChange={setDynamicValue} />
          )}
          <button onClick={handleAddPage} className={styles.add}>
            Add Page
          </button>
        </div>
      </Modal>
    </>
  );
}

const DynamicSection = ({ value, onChange }) => {
  const [fields, setFields] = useState([]);
  const tables = useContext(DatabaseValue);
  const handleTableChange = (v) => {
    onChange({ ...value, type: v, slug: "_id" });
  };
  const handleSlugChange = (v) => {
    onChange({ ...value, slug: v });
  };

  useEffect(() => {
    const selected = tables.find((t) => t.id === value.type);
    if (selected) {
      const fields = Object.keys(selected.fields)
        .map((key) => ({ ...selected.fields[key], id: key }))
        .filter((x) => x.type === "Text");
      setFields(fields);
    }
  }, [value, tables]);

  return (
    <div className={styles.dynamicSection}>
      <div className={styles.inputTitle}>Data table of page</div>
      <Table value={value.type} onChange={handleTableChange} />
      <div style={{ marginTop: 12 }} className={styles.inputTitle}>
        Field to use as slug
      </div>
      <Select value={value.slug} onChange={handleSlugChange}>
        {fields.map((f) => {
          return (
            <Option key={f.id} value={f.id}>
              {f.name}
            </Option>
          );
        })}
      </Select>
    </div>
  );
};
